/* eslint-disable max-len,no-plusplus,no-param-reassign */
import Scroll from '../lib/scroll.js';

class AnimateScroll extends Scroll {
  constructor() {
    super();
  }

  init() {
    const navLinks = document.querySelectorAll('#page-links li a, #mobile-tickets, #desktop-tickets, .animated-scroll, [data-animated-scroll]');

    if (navLinks.length) {
      navLinks.forEach((link) => {
        link.addEventListener('click', this.initScroll.bind(this));
      });
    }

    window.addEventListener('animate.link', () => {
      const wrapper = document.querySelector('#ww-booking-form');
      if (wrapper !== null) {
        this.scroll(wrapper, 1250, 'easeInQuad');
      }
    });

    window.addEventListener('animate.scroll', (ev) => {
      let element = ev.detail;

      if (typeof element === 'undefined') {
        return false;
      }

      if (!(element instanceof HTMLElement)) {
        element = document.querySelector(element);
      }

      if (element !== null) {
        this.scroll(element, 1250, 'easeInQuad');
      }

      return true;
    });
  }

  initScroll(ev) {
    if (typeof ev.target.getAttribute('href') === 'undefined') {
      console.warn('[AnimateScroll] Href attribute undefined');
      return;
    }
    if (ev.target.getAttribute('href') === '#') {
      return;
    }
    if (document.querySelector(ev.target.getAttribute('href')) === null) {
      console.warn(`[AnimateScroll] Referenced element does not exist - ${ev.target.getAttribute('href')}`);
      return;
    }

    ev.preventDefault();

    this.scroll(document.querySelector(ev.target.getAttribute('href')), 1250, 'easeInQuad');
  }
}

export default AnimateScroll;
